const initialState = {
  data:{},
  search:'',
  filter:[],
  sort:{
    field:'srvg_desc',
    asc:1
  }
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCH_SRVGS':
      return {
        ...state,
        data: action.payload
      }
    case 'SORT_SRVGS':
      return {
        ...state,
        sort: action.sort
      }
    case 'SEARCH_SRVGS':
      return {
        ...state,
        search: action.search
      }
    case 'FILTER_SRVGS':
      return {
        ...state,
        filter: action.filter
      }
    case 'EDIT_SRVG':
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.srvg_id]:action.payload
        }
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/srvgs.js